export const HeartIcon = ({ className = "w-5 h-5", filled = true }) => (
    <svg
        viewBox="0 0 24 24"
        className={className}
        fill={filled ? "currentColor" : "none"}
        stroke="currentColor"
        strokeWidth="1.5"
        aria-hidden="true"
    >
        <path d="M12 21s-7.5-4.5-9.5-9.5C1.2 8.1 3.6 4.5 7.1 4.5c1.9 0 3.5 1 4.9 2.6C13.4 5.5 15 4.5 16.9 4.5c3.5 0 5.9 3.6 4.6 7C19.5 16.5 12 21 12 21z" />
    </svg>
);

// Hand-drawn heart with rough edges
export const HeartScribble = ({ className = "w-8 h-8", color = "#ff2d6b" }) => (
    <svg
        viewBox="0 0 64 60"
        className={className}
        fill="none"
        stroke={color}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
    >
        <path d="M32 54 C 22 46, 6 36, 6 22 C 6 14, 12 8, 20 8 C 26 8, 30 12, 32 16 C 34 12, 38 8, 44 8 C 52 8, 58 14, 58 22 C 58 36, 42 46, 32 54 Z" />
    </svg>
);

export const Wordmark = ({ size = "text-2xl" }) => (
    <span
        className={`font-display ${size} font-medium tracking-tight`}
        data-testid="luvyn-wordmark"
        aria-label="LUVYN"
        style={{ letterSpacing: "-0.02em" }}
    >
        L
        <span
            style={{ color: "var(--hot)", display: "inline-block" }}
        >
            Ü
        </span>
        VYN
    </span>
);

export const LogoLockup = ({ size = "text-3xl" }) => (
    <a
        href="/"
        className="inline-flex items-center gap-2.5 group"
        data-testid="logo-link"
        aria-label="LÜVYN home"
    >
        <img
            src="/luvyn.png"
            alt="LÜVYN"
            className="h-16 w-auto object-contain"
            data-testid="luvyn-logo-image"
        />
        <Wordmark size={size} />
    </a>
);

export default LogoLockup;
